<template>
  <div v-if="showListing">
    <div class="nft-header">
      <div class="d-flex gap-3 align-items-center">
        <div class="title">
          {{ $t("dashboard.nft.mylisting") }}
        </div>
        <div class="total">
          {{ $t("dashboard.nft.total") }}<strong>{{ nftList.length }}</strong>
        </div>
      </div>
      <router-link to="/pages/nft-all-gsg" class="btn-mint">{{ $t("dashboard.nft.mint") }}</router-link>
    </div>
    <div class="nft-listing-table">
      <b-table
        :items="nftList"
        :fields="fields"
        select-mode="multi"
        selectable
        stacked="sm"
        selected-variant="nft-selected"
        @row-selected="onRowSelected"
        ref="listingTable"
      >
        <template #head(selected)>
          <template v-if="allSelected">
            <span aria-hidden="true" @click="selectAllRows">&#9745;</span>
            <span class="sr-only">Selected</span>
          </template>
          <template v-else>
            <span aria-hidden="true" @click="selectAllRows">&#9744;</span>
            <span class="sr-only">Not selected</span>
          </template>
        </template>

        <template #cell(selected)="{ rowSelected }">
          <template v-if="rowSelected">
            <span aria-hidden="true">&#9745;</span>
            <span class="sr-only">Selected</span>
          </template>
          <template v-else>
            <span aria-hidden="true">&#9744;</span>
            <span class="sr-only">Not selected</span>
          </template>
        </template>

        <template #cell(image)="row">
          <img :src="row.value" alt="NFT" />
        </template>

        <template #cell(name)="row">
            <span @click="showNFT(row.value)">{{ row.value }}</span>
          </template>
  
        <template #cell(price)="row"> {{ row.value }} ETH </template>

        <template #cell(status)="row">
          <span :class="row.value.class">{{ row.value.text }}</span>
        </template>

        <template #cell(actions)="row">
          <b-button size="sm" @click="share(row)" class="mr-1">
            <img src="../../assets/icon-share.svg" alt="Share" />
          </b-button>
          <b-button size="sm" @click="view(row)" class="mr-1">
            <img src="../../assets/icon-eye.svg" alt="View" />
          </b-button>
          <b-button size="sm" @click="shop(row)" class="mr-1">
            <img src="../../assets/icon-cart.svg" alt="Cart" />
          </b-button>
        </template>
      </b-table>
    </div>
  </div>
  <div v-else>
    <NFTDetails :nftID="nftID" @goBack="goBack"></NFTDetails>
  </div>
</template>

<script>
import { BButton, BTable } from "bootstrap-vue";
import NFTDetails from "./NFTDetails.vue";

export default {
  components: {
    BTable,
    BButton,
    NFTDetails
  },
  data() {
    return {
        showListing: true,
      nftList: [],
      fields: [
        {
          key: "selected",
          label: "☐",
          class: "checkboxCell",
        },
        {
          key: "no",
          label: this.$t("dashboard.nft.form.no"),
        },
        {
          key: "image",
          label: "",
          class: "nft-image",
        },
        {
          key: "name",
          label: this.$t("dashboard.nft.form.name"),
        },
        {
          key: "price",
          label: this.$t("dashboard.nft.form.price"),
        },
        {
          key: "status",
          label: this.$t("dashboard.nft.form.status"),
        },
        {
          key: "actions",
          label: this.$t("dashboard.nft.form.actions"),
        },
      ],
      allSelected: false,
      nftID: ""
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData(cat) {
      // 调用API获取数据，根据cat调用相应分类的数据
      console.log(cat);
      this.nftList = [];
      for (let index = 0; index < 4; index++) {
        const element = {
          no: index + 1,
          image: "/images/nft/GSG-00032.png",
          name: "GSG Token #0005" + index,
          price: this.numberWithCommas(Math.floor(Math.random() * 1000) / 100),
          status:
            index % 2
              ? { text: "For Sale", class: "for-sale" }
              : { text: "Hold", class: "hold" },
        };
        this.nftList.push(element);
      }
      // 语言切换后表格标题需要重新初始化一下
      this.fields = [
        {
          key: "selected",
          label: "☐",
          class: "checkboxCell",
        },
        {
          key: "no",
          label: this.$t("dashboard.nft.form.no"),
        },
        {
          key: "image",
          label: "",
          class: "nft-image",
        },
        {
          key: "name",
          label: this.$t("dashboard.nft.form.name"),
        },
        {
          key: "price",
          label: this.$t("dashboard.nft.form.price"),
        },
        {
          key: "status",
          label: this.$t("dashboard.nft.form.status"),
        },
        {
          key: "actions",
          label: this.$t("dashboard.nft.form.actions"),
        },
      ];
    },
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    onRowSelected(items) {
      console.log(items);
    },
    selectAllRows() {
      if (this.allSelected) {
        this.$refs.listingTable.clearSelected();
        this.allSelected = false;
      } else {
        this.$refs.listingTable.selectAllRows();
        this.allSelected = true;
      }
    },
    showNFT(name) {
        this.showListing = false;
        this.nftID = name;
    },
    goBack() {
        this.nftID = "";
        this.showListing = true;
    },
    share(row) {
      console.log(row);
    },
    view(row) {
      console.log(row);
    },
    shop(row) {
      console.log(row);
    },
  },
  watch: {
    "$i18n.locale": function () {
      this.getData();
    },
  },
};
</script>

<style>
.nft-header {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 1rem;
  margin-bottom: 1.5rem;
  .title {
    color: #687b8e;
    font-size: 1.25rem;
    font-weight: 600;
  }
  .total {
    color: #687b8e;
    font-size: 1rem;
  }
}
.btn-mint {
  background: linear-gradient(90deg, #06a5ff 0%, #3dde91 100%);
  color: white;
  border-radius: 1.5rem;
  font-size: 1.5rem;
  font-weight: 600;
  padding: 0.5rem 2rem;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
.nft-listing-table {
  table {
    vertical-align: middle;
    thead {
      tr {
        th {
          background-color: #e6e7f5;
          color: #3b3e51;
          font-size: 0.9rem;
          border: none;
        }
        th:first-of-type {
          border-top-left-radius: 1rem;
        }
        th:last-of-type {
          border-top-right-radius: 1rem;
        }
      }
    }
    .sr-only {
      display: none;
    }
    .checkboxCell {
      font-size: 1rem;
      width: 2.5rem;
    }
    .nft-image {
      padding: 0.5rem;
      img {
        width: 64px;
      }
    }
    .for-sale,
    .hold {
      background-color: #3ab74e;
      padding: 0.3rem 1rem;
      color: white;
      font-size: 0.8rem;
      border-radius: 0.8rem;
      display: block;
      text-align: center;
      width: 100%;
    }
    .for-sale {
      background-color: #3ab74e;
    }
    .hold {
      background-color: #ffb803;
    }
    .btn-secondary {
      background-color: transparent;
      border: none;
    }
  }
}
@media (max-width: 575.98px) {
  .table.b-table.b-table-stacked-sm > tbody > tr {
    text-align: center;
  }
  .table.b-table.b-table-stacked-sm > tbody > tr > .checkboxCell {
    border: none;
  }
  .table.b-table.b-table-stacked-sm > tbody > tr > [data-label]::before {
    display: none;
  }
  .table.b-table.b-table-stacked-sm > tbody > tr > td {
    border: none;
  }
  .table.b-table.b-table-stacked-sm > tbody > tr > td:last-of-type {
    border-bottom: 1px solid #e1e8ed;
  }
  .nft-image {
    text-align: center;
  }
}
/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
    .nft-header {
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }
    .btn-mint {
        margin: 0;
    }
}
</style>
